// extracted by mini-css-extract-plugin
export default {"container":"styles_container__is-84","headerWrapper":"styles_headerWrapper__50aNT"};